import React from "react";
import { withTranslation } from "react-i18next";
import { QueriesAndValidationsPanelView } from "../../views";
import {
  ContractService,
  PlanService,
  LocalStorageService,
  SignerTypeService,
} from "../../../services/index";
import initialState from "../../../utils/initialState";

class QueriesAndValidationsPanelAction extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      contractPlanExist: false,
      userType: "",
      title: props.t(
        "queriesAndValidationsPanelView.titleQueriesAndValidations"
      ),
      cardQueriesValidations: [
        {
          img: "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/menu-icons/requestInquiry.png",
          altImg: props.t("queriesAndValidationsView.requestInquiry"),
          title: props.t("queriesAndValidationsView.requestInquiry"),
          text: props.t("queriesAndValidationsView.textRequestInquiry"),
          url: "/request-signature-detail",
        },
        {
          img: 'https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/menu-icons/calligraphicExcercises.png',
          altImg: props.t('queriesAndValidationsPanelView.calligraphicExcercises'),
          title: props.t('queriesAndValidationsPanelView.calligraphicExcercises'),
          text: props.t('queriesAndValidationsPanelView.textCalligraphicExcercises'),
          url: '/calligraphic-exercise-report-detail'
        },
        {
          img: "https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/menu-icons/validationsSignedDocuments.png",
          title: props.t(
            "queriesAndValidationsPanelView.validationsSignedDocuments"
          ),
          altImg: props.t(
            "queriesAndValidationsPanelView.validationsSignedDocuments"
          ),
          text: props.t(
            "queriesAndValidationsPanelView.textvalidationsSignedDocuments"
          ),
          url: "/validation-signed-documents-detail",
        },
      ],
    };
  }

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  contractService = new ContractService(this.url);
  planService = new PlanService(this.url);
  signerTypeService = new SignerTypeService(this.url);

  async componentDidMount() {
    this.setState({ loading: true });
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    let userContractPlan = initialState["planService.getUserContractAndPlan"];
    let user = this.localStorageService.getLocalStorageItem("user");

    userContractPlan = await this.planService.getUserContractAndPlan(
      this.token
    );
    initialState["planService.getUserContractAndPlan"] = userContractPlan;

    let contractCountTransactions =
      await this.contractService.getContractsTotalTransactions(this.token);

    if (
      userContractPlan.statusCode &&
      userContractPlan.statusCode === -1 &&
      contractCountTransactions.statusCode === 200
    ) {
      this.setState({
        contractPlanExist: false,
        loading: false,
        userType: user.userMetaData.userMifirma.userType.id,
      });
    } else {
      this.setState({
        contractPlanExist: true,
        loading: false,
        userType: user.userMetaData.userMifirma.userType.id,
      });
    }
  }

  onInvitedExistRedirectRegister = async () => {
    this.user = this.localStorageService.getLocalStorageItem("user");
    let userInformation = this.user.userMetaData.userA3Cloud;
    let address = userInformation.address;

    let phone = userInformation.phoneNumber ? userInformation.phoneNumber : "0";
    let externalNumberValue = address.externalNumber
      ? address.externalNumber
      : "";
    let cellPhone = userInformation.cellphoneNumber
      ? userInformation.cellphoneNumber
      : "0";

    let userCapturedInformation = {
      firstName: userInformation.firstName,
      firstLastName: userInformation.firstLastName,
      secondLastName: userInformation.secondLastName,
      phoneNumber: phone,
      cellphoneNumber: cellPhone,
      email: userInformation.email,
      rfc: userInformation.rfc,
      personlDataFill: true,
    };

    await this.localStorageService.setLocalStorageItem(
      "userCapturedInformation",
      userCapturedInformation
    );
    this.props.onInvitedRedirectRegister();
  };


  render() {
    return (
      <div className="standard-wrapper">
        <QueriesAndValidationsPanelView
          {...this.state}
          onInvitedRedirectRegister={this.onInvitedExistRedirectRegister}
        />
      </div>
    );
  }
}

export default withTranslation()(QueriesAndValidationsPanelAction);
